import React from 'react';
const CallHangup = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg viewBox="0 0 37 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
<path d="M7.26126 14.4996L10.2906 11.9354C11.0176 11.3226 11.4417 10.3873 11.4417 9.40356V5.21063C16.016 3.63022 20.9689 3.61409 25.5583 5.21063V9.41969C25.5583 10.4034 25.9824 11.3388 26.7094 11.9516L29.7236 14.4996C30.9353 15.5156 32.662 15.4188 33.7526 14.2577L35.6005 12.2902C36.8122 11.0001 36.8122 8.85526 35.5247 7.64576C25.8158 -1.48193 11.1842 -1.48193 1.47527 7.64576C0.187817 8.85526 0.187818 11.0001 1.39954 12.2902L3.24742 14.2577C4.32283 15.4188 6.04953 15.5156 7.26126 14.4996Z" 
fill="currentColor"/>
</svg>
);


export default CallHangup;